var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"mcq-quiz"},[_c(_setup.MCQStats,{attrs:{"selectedQuiz":_vm.selectedQuiz,"isShowSolution":_vm.isShowSolution,"maxStudentCount":_vm.maxStudentCount}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }